export default __webpack_public_path__ + "static/media/upto90.a4115268.png";